import React from 'react';
import { SvgIconProps, SvgIcon } from '@material-ui/core';

export const ChevronRightOutlinedIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path fillRule="evenodd" transform="translate(8 6)" id="a" d="M1 .71a.996.996 0 0 0 0 1.41L4.88 6 1 9.88a.996.996 0 1 0 1.41 1.41L7 6.7a.996.996 0 0 0 0-1.41L2.41.7C2.03.32 1.39.32 1 .71z" />
  </SvgIcon>
);
